import React from 'react';
import {
  View, StyleSheet,
} from '@react-pdf/renderer';

const styles = StyleSheet.create({
  space: {
    height: 20,
  },

});
const space = () => <View style={styles.space} />;


export default space;
